import { type EventApplicationModuleSpecsFragment } from '../../../../api/fragments/EventApplicationModuleSpecs';
import EmailContents from './EmailContents';
import EventApplicationModuleMainDetails from './EventApplicationModuleMainDetails';
import { type EditMode, HeaderTabs } from './type';
import VehicleAssignments from './VehicleAssignments';

export type EventApplicationModuleDetailsInnerProps = {
    activeTab: HeaderTabs;
    module: EventApplicationModuleSpecsFragment;
    editMode: EditMode;
    setEditMode: (value: EditMode) => void;
};

const EventApplicationModuleDetailsInner = ({
    activeTab,
    module,
    editMode,
    setEditMode,
}: EventApplicationModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.Vehicles:
            return <VehicleAssignments editMode={editMode} module={module} setEditMode={setEditMode} />;

        case HeaderTabs.ModuleDetails:
            return <EventApplicationModuleMainDetails module={module} />;

        case HeaderTabs.EmailContents:
            return <EmailContents module={module} />;

        default:
            return null;
    }
};

export default EventApplicationModuleDetailsInner;
